import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function HomeError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load home')}
      description={t('Something went wrong while loading your workspace home. Please try again.')}
      loggerName='HomeError'
    />
  )
}
